import type { RouterConfig } from '@nuxt/schema'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
    scrollBehavior(to, from, savedPosition) {
        const nuxtApp = useNuxtApp()

        if (history.state.stop) {
            return
        }

        if (history.state.smooth) {
            return {
                el: history.state.smooth,
                behavior: 'smooth',
            }
        }

        if (to.hash) {
            const el = document.querySelector(to.hash) as HTMLElement

            if (!el) {
                return
            }

            const { marginTop } = getComputedStyle(el)

            const marginTopValue = Number.parseInt(marginTop)

            const offset = (document.querySelector(to.hash) as HTMLElement).offsetTop - marginTopValue

            return {
                top: offset,
                behavior: 'smooth',
            }
        }

        if (savedPosition) {
            return new Promise((resolve) => {
                nuxtApp.hooks.hookOnce('page:finish', () => {
                    resolve(savedPosition)
                })
            })
        }

        if (Object.keys(to.query).length) {
            if (Object.keys(to.query).length === 1 && to.query.q) {
                return
            }

            return {
                top: 0,
                behavior: 'smooth',
            }
        }

        if (to.redirectedFrom?.query.page === '1') {
            return {
                top: 0,
                behavior: 'smooth',
            }
        }

        if (from.name) {
            return new Promise((resolve) => {
                nuxtApp.hook('page:finish', () => {
                    resolve({
                        top: 0,
                    })
                })
            })
        }
    },
}
